import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';

import { EntitlementsStateEffects } from './app-global/entitlements/entitlements-state.effects';
import { UserActivityAnalyticsEffects } from './app-global/user-activity/user-activity-analytics.effects';
import { UserActivityEffects } from './app-global/user-activity/user-activity.effects';
import { LoggingEffects } from './app-logging/app-logging.effects';
import { AppEffects } from './app.effects';
import { ChunkLoadRetryEffects } from './chunk-load-retry.effects';

/**
 * This is the Global root state declared in storeModule.forRoot() in app.module.ts
 *
 * It is rare that anything should be added to this store.  If you find yourself in need of
 * adding a new prop here, please review app-global, app-entites, and app-layout.
 * This is where most new global state should be registered or in a domain specific module.
 *
 * Any questions can be directed to the senior engineers.
 */

export interface rootState {
  router: RouterReducerState;
}

export const globalReducers: ActionReducerMap<rootState> = {
  router: routerReducer,
};

export const globalStateEffects = [
  LoggingEffects,
  EntitlementsStateEffects,
  AppEffects,
  ChunkLoadRetryEffects,
  UserActivityEffects,
  UserActivityAnalyticsEffects,
];
